/**
 * @flow
 * @author: Chinmaya
 */

import styled from 'react-emotion'

const Img = styled('img')``

export default Img
